import { ColGroupDef, GridOptions } from '@ag-grid-community/core';

import { SiteCostType } from '@models/sites/site-cost.enum';

import { SITE_COST_SUMMARY_TABLE_DEFAULT_CONFIG } from './site-cost-summary-table-default-config';
import { siteCostSummaryTablePatientVisitsConfig } from './site-cost-summary-table-patient-visits-config';
import { siteCostSummaryTableSiteColumns } from './site-cost-summary-table-site-config';
import { siteCostSummaryTableSiteInvoiceablesConfig } from './site-cost-summary-table-site-invoiceables-config';
import { SiteSummaryGridContext } from '../types/site-summary-grid-context';
import { SiteSummaryGridRow } from '../types/site-summary-grid-row';

export const siteCostSummaryTableConfig = (
  ctx: SiteSummaryGridContext
): GridOptions<SiteSummaryGridRow> => {
  const defaultConfig = SITE_COST_SUMMARY_TABLE_DEFAULT_CONFIG;

  const mapAggregateColumn = new Map<SiteCostType, () => ColGroupDef<SiteSummaryGridRow>>([
    [SiteCostType.PATIENT_INVOICEABLES, () => siteCostSummaryTablePatientVisitsConfig(ctx)],
    [SiteCostType.PATIENT_VISITS, () => siteCostSummaryTablePatientVisitsConfig(ctx)],
    [SiteCostType.SITE_INVOICEABLES, () => siteCostSummaryTableSiteInvoiceablesConfig(ctx)],
  ]);

  const aggregateColumn = mapAggregateColumn.get(ctx.siteCostType)?.();
  const siteColumns = siteCostSummaryTableSiteColumns(ctx);

  const columnDefs = aggregateColumn ? [siteColumns, aggregateColumn] : [siteColumns];

  return {
    ...defaultConfig,
    columnDefs,
  };
};
